import React, { Component } from 'react';
import MachineScanView from '../views/MachineScanView';

class MachineScanContainer extends Component {
    render() {
        return (
            <MachineScanView />
        );
    }
}
export default MachineScanContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineScanContainer.js